var ee = Object.defineProperty;
var te = (s, n, e) => n in s ? ee(s, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[n] = e;
var a = (s, n, e) => te(s, typeof n != "symbol" ? n + "" : n, e);
import { useState as _, useCallback as k, useMemo as re, useEffect as q, useRef as A } from "react";
import { s as se, i as ne } from "../isEqual-BOTzsXCr.js";
import { c as h, d as oe, s as H, f as z, a as ae, g as ie, l as $, i as ce, w as X, e as ue } from "../protectedTokens-CpdGM6ML.js";
import { t as M, a as U, k as le, l as de, n as we, g as V, e as fe } from "../en-US-DzLLmR2o.js";
import { u as pe } from "../index-DPAF9Zry.js";
function Z(s, n) {
  const e = M(s);
  return isNaN(n) ? h(s, NaN) : (n && e.setDate(e.getDate() + n), e);
}
function he() {
  return Object.assign({}, U());
}
function ye(s) {
  let e = M(s).getDay();
  return e === 0 && (e = 7), e;
}
function xe(s, n) {
  const e = n instanceof Date ? h(n, 0) : new n(0);
  return e.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    s.getDate()
  ), e.setHours(
    s.getHours(),
    s.getMinutes(),
    s.getSeconds(),
    s.getMilliseconds()
  ), e;
}
const me = 10;
class K {
  constructor() {
    a(this, "subPriority", 0);
  }
  validate(n, e) {
    return !0;
  }
}
class be extends K {
  constructor(n, e, r, t, o) {
    super(), this.value = n, this.validateValue = e, this.setValue = r, this.priority = t, o && (this.subPriority = o);
  }
  validate(n, e) {
    return this.validateValue(n, this.value, e);
  }
  set(n, e, r) {
    return this.setValue(n, e, this.value, r);
  }
}
class ge extends K {
  constructor() {
    super(...arguments);
    a(this, "priority", me);
    a(this, "subPriority", -1);
  }
  set(e, r) {
    return r.timestampIsSet ? e : h(e, xe(e, Date));
  }
}
class u {
  run(n, e, r, t) {
    const o = this.parse(n, e, r, t);
    return o ? {
      setter: new be(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(n, e, r) {
    return !0;
  }
}
class Te extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 140);
    a(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(e, { width: "abbreviated" }) || t.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return t.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(e, { width: "wide" }) || t.era(e, { width: "abbreviated" }) || t.era(e, { width: "narrow" });
    }
  }
  set(e, r, t) {
    return r.era = t, e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const f = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, b = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function p(s, n) {
  return s && {
    value: n(s.value),
    rest: s.rest
  };
}
function l(s, n) {
  const e = n.match(s);
  return e ? {
    value: parseInt(e[0], 10),
    rest: n.slice(e[0].length)
  } : null;
}
function g(s, n) {
  const e = n.match(s);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, t = e[2] ? parseInt(e[2], 10) : 0, o = e[3] ? parseInt(e[3], 10) : 0, i = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (t * le + o * de + i * we),
    rest: n.slice(e[0].length)
  };
}
function J(s) {
  return l(f.anyDigitsSigned, s);
}
function w(s, n) {
  switch (s) {
    case 1:
      return l(f.singleDigit, n);
    case 2:
      return l(f.twoDigits, n);
    case 3:
      return l(f.threeDigits, n);
    case 4:
      return l(f.fourDigits, n);
    default:
      return l(new RegExp("^\\d{1," + s + "}"), n);
  }
}
function Y(s, n) {
  switch (s) {
    case 1:
      return l(f.singleDigitSigned, n);
    case 2:
      return l(f.twoDigitsSigned, n);
    case 3:
      return l(f.threeDigitsSigned, n);
    case 4:
      return l(f.fourDigitsSigned, n);
    default:
      return l(new RegExp("^-?\\d{1," + s + "}"), n);
  }
}
function N(s) {
  switch (s) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function j(s, n) {
  const e = n > 0, r = e ? n : 1 - n;
  let t;
  if (r <= 50)
    t = s || 100;
  else {
    const o = r + 50, i = Math.trunc(o / 100) * 100, y = s >= o % 100;
    t = s + i - (y ? 100 : 0);
  }
  return e ? t : 1 - t;
}
function S(s) {
  return s % 400 === 0 || s % 4 === 0 && s % 100 !== 0;
}
class ke extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 130);
    a(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, t) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return p(w(4, e), o);
      case "yo":
        return p(
          t.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return p(w(r.length, e), o);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, t) {
    const o = e.getFullYear();
    if (t.isTwoDigitYear) {
      const y = j(
        t.year,
        o
      );
      return e.setFullYear(y, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in r) || r.era === 1 ? t.year : 1 - t.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Me extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 130);
    a(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return p(w(4, e), o);
      case "Yo":
        return p(
          t.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return p(w(r.length, e), o);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, t, o) {
    const i = oe(e, o);
    if (t.isTwoDigitYear) {
      const x = j(
        t.year,
        i
      );
      return e.setFullYear(
        x,
        0,
        o.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), H(e, o);
    }
    const y = !("era" in r) || r.era === 1 ? t.year : 1 - t.year;
    return e.setFullYear(y, 0, o.firstWeekContainsDate), e.setHours(0, 0, 0, 0), H(e, o);
  }
}
class De extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 130);
    a(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r) {
    return Y(r === "R" ? 4 : r.length, e);
  }
  set(e, r, t) {
    const o = h(e, 0);
    return o.setFullYear(t, 0, 4), o.setHours(0, 0, 0, 0), z(o);
  }
}
class Pe extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 130);
    a(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r) {
    return Y(r === "u" ? 4 : r.length, e);
  }
  set(e, r, t) {
    return e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class _e extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 120);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return w(r.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, t) {
    return e.setMonth((t - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Le extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 120);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return w(r.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, t) {
    return e.setMonth((t - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ee extends u {
  constructor() {
    super(...arguments);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    a(this, "priority", 110);
  }
  parse(e, r, t) {
    const o = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return p(
          l(f.month, e),
          o
        );
      // 01, 02, ..., 12
      case "MM":
        return p(w(2, e), o);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return p(
          t.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return t.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(e, { width: "wide", context: "formatting" }) || t.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.setMonth(t, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ye extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 110);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const o = (i) => i - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return p(
          l(f.month, e),
          o
        );
      // 01, 02, ..., 12
      case "LL":
        return p(w(2, e), o);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return p(
          t.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return t.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(e, { width: "wide", context: "standalone" }) || t.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.setMonth(t, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Oe(s, n, e) {
  const r = M(s), t = ae(r, e) - n;
  return r.setDate(r.getDate() - t * 7), r;
}
class Ie extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 100);
    a(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "w":
        return l(f.week, e);
      case "wo":
        return t.ordinalNumber(e, { unit: "week" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, t, o) {
    return H(Oe(e, t, o), o);
  }
}
function He(s, n) {
  const e = M(s), r = ie(e) - n;
  return e.setDate(e.getDate() - r * 7), e;
}
class qe extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 100);
    a(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "I":
        return l(f.week, e);
      case "Io":
        return t.ordinalNumber(e, { unit: "week" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, t) {
    return z(He(e, t));
  }
}
const Ne = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ve = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ce extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "subPriority", 1);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "d":
        return l(f.date, e);
      case "do":
        return t.ordinalNumber(e, { unit: "date" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    const t = e.getFullYear(), o = S(t), i = e.getMonth();
    return o ? r >= 1 && r <= ve[i] : r >= 1 && r <= Ne[i];
  }
  set(e, r, t) {
    return e.setDate(t), e.setHours(0, 0, 0, 0), e;
  }
}
class Re extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "subpriority", 1);
    a(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    switch (r) {
      case "D":
      case "DD":
        return l(f.dayOfYear, e);
      case "Do":
        return t.ordinalNumber(e, { unit: "date" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    const t = e.getFullYear();
    return S(t) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(e, r, t) {
    return e.setMonth(0, t), e.setHours(0, 0, 0, 0), e;
  }
}
function v(s, n, e) {
  var P, E, T, L;
  const r = U(), t = (e == null ? void 0 : e.weekStartsOn) ?? ((E = (P = e == null ? void 0 : e.locale) == null ? void 0 : P.options) == null ? void 0 : E.weekStartsOn) ?? r.weekStartsOn ?? ((L = (T = r.locale) == null ? void 0 : T.options) == null ? void 0 : L.weekStartsOn) ?? 0, o = M(s), i = o.getDay(), x = (n % 7 + 7) % 7, D = 7 - t, O = n < 0 || n > 6 ? n - (i + D) % 7 : (x + D) % 7 - (i + D) % 7;
  return Z(o, O);
}
class Qe extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return t.day(e, { width: "wide", context: "formatting" }) || t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, o) {
    return e = v(e, t, o), e.setHours(0, 0, 0, 0), e;
  }
}
class We extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t, o) {
    const i = (y) => {
      const x = Math.floor((y - 1) / 7) * 7;
      return (y + o.weekStartsOn + 6) % 7 + x;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return p(w(r.length, e), i);
      // 3rd
      case "eo":
        return p(
          t.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "eee":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return t.day(e, { width: "wide", context: "formatting" }) || t.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.day(e, { width: "short", context: "formatting" }) || t.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, o) {
    return e = v(e, t, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Be extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, r, t, o) {
    const i = (y) => {
      const x = Math.floor((y - 1) / 7) * 7;
      return (y + o.weekStartsOn + 6) % 7 + x;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return p(w(r.length, e), i);
      // 3rd
      case "co":
        return p(
          t.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "ccc":
        return t.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return t.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return t.day(e, { width: "wide", context: "standalone" }) || t.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || t.day(e, { width: "short", context: "standalone" }) || t.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, t, o) {
    return e = v(e, t, o), e.setHours(0, 0, 0, 0), e;
  }
}
function Fe(s, n) {
  const e = M(s), r = ye(e), t = n - r;
  return Z(e, t);
}
class Ge extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 90);
    a(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, t) {
    const o = (i) => i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return w(r.length, e);
      // 2nd
      case "io":
        return t.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return p(
          t.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // T
      case "iiiii":
        return p(
          t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tu
      case "iiiiii":
        return p(
          t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tuesday
      case "iiii":
      default:
        return p(
          t.day(e, {
            width: "wide",
            context: "formatting"
          }) || t.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || t.day(e, {
            width: "short",
            context: "formatting"
          }) || t.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 7;
  }
  set(e, r, t) {
    return e = Fe(e, t), e.setHours(0, 0, 0, 0), e;
  }
}
class $e extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 80);
    a(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(N(t), 0, 0, 0), e;
  }
}
class Xe extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 80);
    a(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(N(t), 0, 0, 0), e;
  }
}
class Ae extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 80);
    a(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || t.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, t) {
    return e.setHours(N(t), 0, 0, 0), e;
  }
}
class ze extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 70);
    a(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "h":
        return l(f.hour12h, e);
      case "ho":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 12;
  }
  set(e, r, t) {
    const o = e.getHours() >= 12;
    return o && t < 12 ? e.setHours(t + 12, 0, 0, 0) : !o && t === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(t, 0, 0, 0), e;
  }
}
class Ue extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 70);
    a(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "H":
        return l(f.hour23h, e);
      case "Ho":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 23;
  }
  set(e, r, t) {
    return e.setHours(t, 0, 0, 0), e;
  }
}
class Ve extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 70);
    a(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "K":
        return l(f.hour11h, e);
      case "Ko":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, t) {
    return e.getHours() >= 12 && t < 12 ? e.setHours(t + 12, 0, 0, 0) : e.setHours(t, 0, 0, 0), e;
  }
}
class Ze extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 70);
    a(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "k":
        return l(f.hour24h, e);
      case "ko":
        return t.ordinalNumber(e, { unit: "hour" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 24;
  }
  set(e, r, t) {
    const o = t <= 24 ? t % 24 : t;
    return e.setHours(o, 0, 0, 0), e;
  }
}
class Ke extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 60);
    a(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "m":
        return l(f.minute, e);
      case "mo":
        return t.ordinalNumber(e, { unit: "minute" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, t) {
    return e.setMinutes(t, 0, 0), e;
  }
}
class Je extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 50);
    a(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, t) {
    switch (r) {
      case "s":
        return l(f.second, e);
      case "so":
        return t.ordinalNumber(e, { unit: "second" });
      default:
        return w(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, t) {
    return e.setSeconds(t, 0), e;
  }
}
class je extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 30);
    a(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r) {
    const t = (o) => Math.trunc(o * Math.pow(10, -r.length + 3));
    return p(w(r.length, e), t);
  }
  set(e, r, t) {
    return e.setMilliseconds(t), e;
  }
}
class Se extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 10);
    a(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, r) {
    switch (r) {
      case "X":
        return g(
          b.basicOptionalMinutes,
          e
        );
      case "XX":
        return g(b.basic, e);
      case "XXXX":
        return g(
          b.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return g(
          b.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return g(b.extended, e);
    }
  }
  set(e, r, t) {
    return r.timestampIsSet ? e : h(
      e,
      e.getTime() - V(e) - t
    );
  }
}
class et extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 10);
    a(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, r) {
    switch (r) {
      case "x":
        return g(
          b.basicOptionalMinutes,
          e
        );
      case "xx":
        return g(b.basic, e);
      case "xxxx":
        return g(
          b.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return g(
          b.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return g(b.extended, e);
    }
  }
  set(e, r, t) {
    return r.timestampIsSet ? e : h(
      e,
      e.getTime() - V(e) - t
    );
  }
}
class tt extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 40);
    a(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return J(e);
  }
  set(e, r, t) {
    return [h(e, t * 1e3), { timestampIsSet: !0 }];
  }
}
class rt extends u {
  constructor() {
    super(...arguments);
    a(this, "priority", 20);
    a(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return J(e);
  }
  set(e, r, t) {
    return [h(e, t), { timestampIsSet: !0 }];
  }
}
const st = {
  G: new Te(),
  y: new ke(),
  Y: new Me(),
  R: new De(),
  u: new Pe(),
  Q: new _e(),
  q: new Le(),
  M: new Ee(),
  L: new Ye(),
  w: new Ie(),
  I: new qe(),
  d: new Ce(),
  D: new Re(),
  E: new Qe(),
  e: new We(),
  c: new Be(),
  i: new Ge(),
  a: new $e(),
  b: new Xe(),
  B: new Ae(),
  h: new ze(),
  H: new Ue(),
  K: new Ve(),
  k: new Ze(),
  m: new Ke(),
  s: new Je(),
  S: new je(),
  X: new Se(),
  x: new et(),
  t: new tt(),
  T: new rt()
}, nt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, at = /^'([^]*?)'?$/, it = /''/g, ct = /\S/, ut = /[a-zA-Z]/;
function lt(s, n, e, r) {
  var C, R, Q, W;
  const t = he(), o = t.locale ?? fe, i = t.firstWeekContainsDate ?? ((R = (C = t.locale) == null ? void 0 : C.options) == null ? void 0 : R.firstWeekContainsDate) ?? 1, y = t.weekStartsOn ?? ((W = (Q = t.locale) == null ? void 0 : Q.options) == null ? void 0 : W.weekStartsOn) ?? 0;
  if (n === "")
    return s === "" ? M(e) : h(e, NaN);
  const x = {
    firstWeekContainsDate: i,
    weekStartsOn: y,
    locale: o
  }, D = [new ge()], O = n.match(ot).map((c) => {
    const d = c[0];
    if (d in $) {
      const m = $[d];
      return m(c, o.formatLong);
    }
    return c;
  }).join("").match(nt), P = [];
  for (let c of O) {
    ce(c) && X(c, n, s), ue(c) && X(c, n, s);
    const d = c[0], m = st[d];
    if (m) {
      const { incompatibleTokens: B } = m;
      if (Array.isArray(B)) {
        const F = P.find(
          (G) => B.includes(G.token) || G.token === d
        );
        if (F)
          throw new RangeError(
            `The format string mustn't contain \`${F.fullToken}\` and \`${c}\` at the same time`
          );
      } else if (m.incompatibleTokens === "*" && P.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${c}\` and any other token at the same time`
        );
      P.push({ token: d, fullToken: c });
      const I = m.run(
        s,
        c,
        o.match,
        x
      );
      if (!I)
        return h(e, NaN);
      D.push(I.setter), s = I.rest;
    } else {
      if (d.match(ut))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + d + "`"
        );
      if (c === "''" ? c = "'" : d === "'" && (c = dt(c)), s.indexOf(c) === 0)
        s = s.slice(c.length);
      else
        return h(e, NaN);
    }
  }
  if (s.length > 0 && ct.test(s))
    return h(e, NaN);
  const E = D.map((c) => c.priority).sort((c, d) => d - c).filter((c, d, m) => m.indexOf(c) === d).map(
    (c) => D.filter((d) => d.priority === c).sort((d, m) => m.subPriority - d.subPriority)
  ).map((c) => c[0]);
  let T = M(e);
  if (isNaN(T.getTime()))
    return h(e, NaN);
  const L = {};
  for (const c of E) {
    if (!c.validate(T, x))
      return h(e, NaN);
    const d = c.set(T, L, x);
    Array.isArray(d) ? (T = d[0], Object.assign(L, d[1])) : T = d;
  }
  return h(e, T);
}
function dt(s) {
  return s.match(at)[1].replace(it, "'");
}
const wt = (s, n) => (s = s.replace(
  new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
  (e) => e.toLowerCase()
), s.replace(
  new RegExp("(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
  (e, r, t) => r + n + t.toLowerCase()
));
function ft(s, {
  separator: n = "_",
  preserveConsecutiveUppercase: e = !1
} = {}) {
  if (!(typeof s == "string" && typeof n == "string"))
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  if (s.length < 2)
    return e ? s : s.toLowerCase();
  const r = `$1${n}$2`, t = s.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    r
  );
  return e ? wt(t, n) : t.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    r
  ).toLowerCase();
}
const kt = (s) => se(s, { lower: !0 }), Mt = (s) => {
  const [n, e] = _(s), [r, t] = _(""), o = k((i) => {
    t(""), e(i);
  }, []);
  return {
    value: n,
    onInput: o,
    error: r,
    setError: t,
    setValue: e
  };
}, Dt = (s) => {
  const [n, e] = _(s ?? !1);
  q(() => {
    e(s ?? !1);
  }, [s]);
  const r = k(
    (t) => {
      e(t.currentTarget.checked);
    },
    []
  );
  return {
    value: n,
    handleChange: r
  };
}, Pt = (s) => s instanceof Error ? s.message : typeof s == "string" ? s : "", _t = () => {
  const [s, n] = _("xl"), e = k(() => {
    const r = window.innerWidth;
    r < 576 ? n("xs") : r < 768 ? n("sm") : r < 992 ? n("md") : r < 1200 ? n("lg") : r < 1400 ? n("xl") : n("xxl");
  }, []);
  return q(() => (e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e)), [e]), s;
}, Lt = (s) => {
  const n = [
    "dd/MM/yyyy",
    "dd-MM-yyyy",
    "dd.MM.yyyy",
    "yyyy/MM/dd",
    "yyyy-MM-dd",
    "yyyy.MM.dd"
  ];
  for (const e of n)
    try {
      const r = lt(s, e, /* @__PURE__ */ new Date());
      if (isNaN(r.getTime())) throw new Error();
      return r;
    } catch {
      continue;
    }
}, Et = () => "ontouchstart" in window || navigator.maxTouchPoints > 0;
function Yt(s) {
  var n;
  return s.length === 0 ? s : `${(n = s[0]) == null ? void 0 : n.toLowerCase()}${s.slice(1)}`;
}
const Ot = () => {
  const s = pe();
  return k(() => {
    s("..", { relative: "path" });
  }, [s]);
}, It = (s) => s != null;
function Ht(s, n) {
  const e = A();
  return (!e.current || !ne(n, e.current.key)) && (e.current = { key: n, value: s() }), e.current.value;
}
function qt(s) {
  const n = "." + s, e = [];
  for (let r = 0; r < document.styleSheets.length; r++) {
    const t = document.styleSheets[r];
    try {
      for (let o = 0; o < t.cssRules.length; o++) {
        const i = t.cssRules[o];
        i instanceof CSSStyleRule && i.selectorText === n && e.push(i.style);
      }
    } catch {
    }
  }
  return e.map((r) => ({
    style: r,
    className: s
  }));
}
const Nt = (s) => {
  const n = A(!1);
  q(() => {
    n.current || (n.current = !0, s());
  }, [s]);
}, vt = (...s) => k(
  (n) => {
    s.forEach((e) => {
      typeof e == "function" ? e(n) : e && (e.current = n);
    });
  },
  [s]
);
function Ct() {
  const [s, n] = _(null), e = k((r) => {
    n(r);
  }, []);
  return { element: s, ref: e };
}
function pt(s) {
  var n;
  return !s || s.length === 0 ? s : `${(n = s[0]) == null ? void 0 : n.toUpperCase()}${s.slice(1)}`;
}
const Rt = (s, n, e) => Math.min(e, Math.max(n, s)), Qt = (s = !1) => {
  const [n, e] = _(s), r = k(() => e(!0), []), t = k(() => e(!1), []), o = k(() => e((i) => !i), []);
  return [n, r, t, o];
}, Wt = (s, n) => (s == null ? void 0 : s.toLowerCase()) === (n == null ? void 0 : n.toLowerCase()), Bt = (s = "") => ft(s, {
  separator: " "
});
function Ft(s, n = "id") {
  return `${s == null ? void 0 : s[0].toLowerCase()}${s == null ? void 0 : s.slice(
    1
  )}${pt(n)}`;
}
class Gt {
  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    a(this, "pairs", []);
  }
  when(...n) {
    return this.pairs.push(n), this;
  }
  choose(n, e, r) {
    for (const [t, o] of this.pairs)
      if (t(e))
        return o(e, r);
    return n(e, r);
  }
}
const $t = (s) => {
  if (!s)
    return {};
  const n = {};
  for (const e in s)
    s[e] && typeof s[e] == "string" && (n[`--app-${e}`] = s[e]);
  return n;
}, ht = (s, n, e) => {
  const { [s]: r = {}, ...t } = e, o = {
    ...r
  };
  for (const i of n)
    o[i] = o[i] || t[i];
  return o;
}, Xt = (s, n, e) => re(
  () => ht(s, Object.keys(n), e),
  [s, n, e]
);
export {
  Gt as TypeNarrowingExpression,
  Bt as buildLabelFromName,
  $t as buildThemeVariables,
  Rt as clamp,
  Wt as equalsWhenLowerCased,
  qt as findCSSClassDefinitions,
  Pt as getErrorMessage,
  Ft as idFromObjectName,
  It as isNotNil,
  Et as isTouchDevice,
  Yt as lowerCaseFirstLetter,
  ht as mergeThemeVariables,
  kt as nameToSlug,
  Lt as parseUnkownDate,
  pt as upperCaseFirstLetter,
  Qt as useBoolean,
  _t as useBreakpoint,
  Dt as useCheckbox,
  Ht as useDeepMemo,
  Nt as useEffectOnce,
  Ct as useElement,
  Ot as useGoBack,
  Mt as useInput,
  vt as useMergeRefs,
  Xt as useMergeThemeVariables
};
